import { useState, useEffect, useCallback } from 'react';
import * as API from '../lib/JerseyDirectoryAPI';

function UseSearchDirectoryList() {
    const [listings, setListings] = useState([]);
    const [isListingsLoaded, setIsListingsLoaded] = useState(false);
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [selectedListing, setSelectedListing] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;
    const [searchText, setSearchText] = useState('');
    const [filteredEntries, setFilteredEntries] = useState([]);
    const [isEntriesFiltered, setIsEntriesFiltered] = useState(false);
    const [resultsCount, setResultsCount] = useState(0);

    useEffect(() => {
        API.getAllDirectoryEntries()
            .then(response => {
                let deserializedEntries = response.data;
                setListings(deserializedEntries);
                setFilteredEntries(deserializedEntries);
                setIsListingsLoaded(true);
                setIsEntriesFiltered(true);
                setCurrentPage(1);
            })
            .catch(error => {
            });
    }, []);

    const filterListings = async (listings, searchText) => {
        var data = listings;
        if (searchText != null) {
            let search = searchText.replace(/\s/g, '').toUpperCase();
            data = data.filter(item => {
                return item["IndexOrganizationName"]?.toUpperCase().includes(search) ||
                       item["IndexOwnerName"]?.toUpperCase().includes(search) ||
                       item["FirstName"]?.toUpperCase().includes(search) ||
                       item["LastName"]?.toUpperCase().includes(search) ||
                       item["Email"]?.toUpperCase().includes(search) ||
                       item["StateProvince"]?.toUpperCase().includes(search) ||
                       (typeof item["CustomerNumber"] === 'number' && item["CustomerNumber"].toString().includes(searchText));
            });
        }
        return data;
    };

    useEffect(() => {
        async function filterData() {
            setIsEntriesFiltered(false);
            var filteredData = await filterListings(listings, searchText);
            setFilteredEntries(filteredData);
            setIsEntriesFiltered(true);
        }
        filterData();
    }, [listings, searchText]);

    useEffect(() => {
        setResultsCount(filteredEntries?.length ?? 0);
    }, [filteredEntries]);

    const handleCheckboxChange = (ID) => {
        setSelectedRecords(prevSelectedRecords =>
            prevSelectedRecords.includes(ID)
                ? prevSelectedRecords.filter(recordId => recordId !== ID)
                : [ID]
        );
    };

    const handleSelectClick = () => {
        const selected = listings.find(listing => listing.ID === selectedRecords[0]);
        setSelectedListing(selected);
    };

    const handleSearchTextChanged = useCallback((e) => {
        setSearchText(e.target.value);
    }, []);

    const paginatedResults = filteredEntries.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filteredEntries.length / itemsPerPage);

    return {
        listings,
        selectedRecords,
        selectedListing,
        currentPage,
        itemsPerPage,
        paginatedResults,
        totalPages,
        resultsCount,
        isEntriesFiltered,
        isListingsLoaded,
        handleCheckboxChange,
        handleSelectClick,
        setCurrentPage,
        setIsListingsLoaded,
        setSearchText,
        handleSearchTextChanged,
        searchText
    };
}

export default UseSearchDirectoryList;